"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.delete.confirm': '删除教程',
    'tutorial.delete.confirmText': '您确定要删除此教程吗？此操作无法撤消。',
    'tutorial.delete.success': '教程删除成功',
};
